export function cycleCountJobsGridColumns(titleArray) {
    return [
        {
            field: "RowNumber",
            title: "Row",
            rowNumberHeaderTitle: "Row",
            width: 90,
            minResizableWidth: 70,
            wmsid: 1,
            hidden: false,
            locked: true,
            lockable: false,
            resizable: true,
            sortable: false,
            reorderable: false,
            filterable: false,
            attributes: { style: "text-align: center" },
            headerAttributes: { style: "text-align: center" },
        },
        {
            field: "Name",
            title: titleArray[0].description,
            width: 120,
            wmsid: 1,
            filterable: true,
            lockable: false,
        },
        {
            field: "BatchName",
            title: "Batch Name",
            width: 150,
            wmsid: 1,
            filterable: true,
            lockable: false,
        },
        {
            field: "CreationDate",
            title: titleArray[1].description,
            template: "#= CreationDate != null ? kendo.toString(kendo.parseDate(CreationDate), 'MMM dd,yyyy') : '' #",
            width: 120,
            wmsid: 2,
            filterable: true,
            lockable: false,
        },
        {
            field: "ClosedDate",
            title: titleArray[7].description,
            template: "#= ClosedDate != null ? kendo.toString(kendo.parseDate(ClosedDate), 'MMM dd,yyyy') : '' #",
            width: 120,
            wmsid: 2,
            filterable: true,
            lockable: false,
        },
        {
            field: "AuditType",
            title: titleArray[2].description,
            width: 120,
            wmsid: 3,
            filterable: true,
            lockable: false,
        },
        {
            field: "StatusName",
            title: titleArray[3].description,
            width: 120,
            wmsid: 4,
            filterable: true,
            lockable: false,
        },
        {
            field: "NumberOfLocations",
            title: titleArray[4].description,
            width: 120,
            wmsid: 5,
            filterable: true,
            lockable: false,
        },
        {
            field: "AssignedTo.Name",
            title: titleArray[5].description,
            template: "#= AssignedTo != null ? AssignedTo.Name : '' #",
            width: 120,
            wmsid: 6,
            filterable: true,
            lockable: false,
        },
        {
            field: "UseTrackBys",
            title: titleArray[6].description,
            template: "#= UseTrackBys == true ? 'Yes' : 'No' #",
            width: 120,
            wmsid: 7,
            filterable: true,
            lockable: false,
        },
        {
            field: "Sku",
            title: titleArray[8].description,
            template: "#= Sku !== null ? Sku : '' #",
            width: 120,
            wmsid: 8,
            filterable: true,
            lockable: false,
        },
    ];
}
export function cycleCountJobsGridSchema() {
    return {
        model: {
            id: "EditUri",
            fields: {
                Name: {
                    type: "string",
                },
                BatchName: {
                    type: "string",
                },
                CreationDate: {
                    type: "string",
                },
                ClosedDate: {
                    type: "string",
                },
                AuditType: {
                    type: "string",
                },
                NumberOfLocations: {
                    type: "number",
                },
                UseTrackBys: {
                    type: "boolean",
                },
                Status: {
                    type: "string",
                },
                AssignedTo: {
                    type: "any",
                },
                Sku: {
                    type: "string",
                },
            },
        },
    };
}

export function itemsGridColumns() {
    return [
        {
            selectable: true,
            width: 40,
            // eslint-disable-next-line sonarjs/no-duplicate-string
            attributes: { class: "k-text-center" },
            headerAttributes: { class: "k-text-center" },
        },
        {
            field: "Name",
            title: "Locations",
            width: "100%",
            wmsid: 1,
            filterable: true,
        },
        {
            field: "Type",
            title: "Location Type",
            width: "80%",
            wmsid: 4,
            filterable: true,
        },
        {
            field: "Deactivated",
            title: "Status",
            width: "100%",
            wmsid: 6,
            template: "#= Deactivated ? 'Inactive' : 'Active' #",
            filterable: {
                extra: false,
                messages: {
                    info: "Show locations with status:",
                    isTrue: "Inactive",
                    isFalse: "Active",
                },
            },
        },
    ];
}
export function locationsGridColumns() {
    return [
        {
            selectable: true,
            width: 40,
            // eslint-disable-next-line sonarjs/no-duplicate-string
            attributes: { class: "k-text-center" },
            headerAttributes: { class: "k-text-center" },
        },
        {
            field: "Name",
            title: "Locations",
            width: "100%",
            wmsid: 1,
            filterable: true,
        },
        {
            field: "LastCounted",
            title: "LastCounted",
            width: "100%",
            wmsid: 3,
            filterable: true,
        },
        {
            field: "Type",
            title: "Location Type",
            width: "80%",
            wmsid: 4,
            filterable: true,
        },
        {
            field: "Deactivated",
            title: "Status",
            width: "100%",
            wmsid: 6,
            template: "#= Deactivated ? 'Inactive' : 'Active' #",
            filterable: {
                extra: false,
                messages: {
                    info: "Show locations with status:",
                    isTrue: "Inactive",
                    isFalse: "Active",
                },
            },
        },
    ];
}
export function locationsGridSchema() {
    return {
        schema: {
            data: "Data",
            total: "Total",
            model: {
                id: "Id",
                fields: {
                    Name: {
                        type: "string",
                    },
                    LastCounted: {
                        type: "string",
                    },
                    Type: {
                        type: "string",
                    },
                    Deactivated: {
                        type: "boolean",
                    },
                },
            },
        },
    };
}
export const getGridDemoAuditLocationsGridRead = (facilityId, auditType, pastndays, ItemId, isSuggestedLocation) => {
    let dataPayload = null;
    dataPayload = {
        facilityId: facilityId,
        auditType: auditType,
        filter: "Deactivated~eq~false",
        itemid: ItemId,
    };
    if (isSuggestedLocation) {
        dataPayload.pastndays = pastndays;
    }
    return {
        transport: {
            read: {
                url:
                    auditType === "Location"
                        ? "/WebUI/Inventory/EditAudits/AuditLocationsGridRead"
                        : "/WebUI/Inventory/EditAudits/ItemAuditLocationsGridRead",
                type: "POST",
                data: dataPayload,
                dataType: "json",
            },
            destroy: {
                url:
                    auditType === "Location"
                        ? "/WebUI/Inventory/EditAudits/AuditLocationsGridRead"
                        : "/WebUI/Inventory/EditAudits/ItemAuditLocationsGridRead",
                type: "GET",
                dataType: "JSON",
            },
            parameterMap: function (options, operation) {
                if (operation !== "read" && options.models) {
                    return {
                        models: JSON.stringify(options.models),
                    };
                }
            },
        },
    };
};

export function jobLocationsGridSchema() {
    return {
        schema: {
            model: {
                id: "Id",
                fields: {
                    Name: {
                        type: "string",
                    },
                },
            },
        },
    };
}
export function jobLocationsGridColumns(auditType) {
    return [
        {
            selectable: true,
            width: 20,
            headerAttributes: { class: "k-text-center" },
            attributes: {
                "class": "#=IsRequired ? 'k-text-center  k-state-disabled k-hide-chield':'k-text-center '#",
            },
        },
        {
            field: "Name",
            title: "Locations",
            width: 120,
            attributes: { class: auditType === "Item" ? "audit-type-item" : "audit-type-location" },
            headerTemplate: "Locations ",
            template: function (dataItem) {
                let format = "";
                if (auditType === "Item" && (dataItem.IsRequired || dataItem.IsSuggested)) {
                    format = dataItem.IsRequired
                        ? "<span class='required-label-wrapper'><label>R</label></span>"
                        : "<span class='suggested-label-wrapper'><label>S</label></span>";
                }
                return format + dataItem.Name;
            },
            wmsid: 1,
            filterable: true,
        },
    ];
}
